import * as styles from "./error-fallback.module.css";

// Generic, partner-facing copy. We deliberately do NOT render
// `error.message` — that can leak implementation detail (e.g. property
// names from undefined accesses, internal IDs from API failures).
// The DD RUM ErrorBoundary captures the original error for ops with
// the full stack and message; this component is just the user-facing
// fallback.
export function ErrorFallback(): JSX.Element {
  return (
    <main className={styles.shell} role="alert">
      <div className={styles.card}>
        <h1 className={styles.title}>Something went wrong</h1>
        <p className={styles.subtitle}>
          Please reload the page or try again in a minute.
        </p>
      </div>
    </main>
  );
}
